// Self-contained data for the COVO 24K GOLD HK website.
// No dependencies on the MySiteCare site — this folder (/src/covo) is exportable.

export const COVO = {
  name: "COVO 24K GOLD HK",
  brand: "COVO JEWELRY",
  sub: "24K Hong Kong Gold",
  category: "Jewelry Wholesaler & Retailer",
  intro:
    "COVO is an established Ongpin, Manila gold seller specializing in 24K Hong Kong gold — Piyao charms, custom bracelets, chains, rings, pendants and gold beads. Publicly documented since 2019.",
  purityNote:
    "Selected COVO pieces are advertised as 24K / 999.9 Hong Kong gold. Always confirm purity, weight and price in person before purchase.",
  fbFollowers: "84K+",
  fbRecommend: "96%",
  fbReviews: 82,
  email: "2069619899@qq.com",
  messenger: "https://m.me/100064034741613",
  facebook: "https://www.facebook.com/profile.php?id=100064034741613",
  communityName: "Jewelry Stocks Update (COVO)",
  communityMembers: "1.8K members",
  communityLink: "https://www.facebook.com/messages/t/1822118198743609/",
  addressMain: "930-C3 Ongpin Street, Sta. Cruz, Manila, Metro Manila, Philippines 1008",
  addressBranch: "M-07 / M-08, 2nd Floor, Chinatown Gold Center, 509 Ronquillo St., Sta. Cruz, Manila",
  phones: ["+63 2 8634 4656", "+63 2 7943 3898"],
  hours: "Mon–Sat, 10:00 AM – 5:00 PM (M7 stall open daily)",
  mapEmbed: "https://www.google.com/maps?q=COVO+Jewelry+930-C3+Ongpin+St+Sta+Cruz+Manila&output=embed",
};

export const HIGHLIGHTS = [
  { title: "24K / 999.9 Hong Kong gold", text: "Specialist in high-purity HK gold; many pieces tagged and pawnable. Purity confirmed in-store." },
  { title: "Trade-ins accepted", text: "Bring old 24K pieces for trade-in, restringing and bead replacement." },
  { title: "Custom bracelets", text: "Combine 24K charms and beads — assembled while you wait." },
  { title: "Wholesale & retail", text: "Wholesalers, retailers and distributors welcome alongside walk-in buyers." },
];

// Real products with weights/purity taken from COVO's own tagged photos.
export const PRODUCTS = [
  {
    name: "Dragon Chain-Link Bracelet",
    purity: "24K HK Gold · 999.9%",
    weight: "25.25 g",
    img: "/covo/prod-chain.webp",
    desc: "Statement patterned link bracelet with dragon-head clasp.",
  },
  {
    name: "Dragon Byzantine Bracelet",
    purity: "24K HK Gold · 999.9%",
    weight: "22.24 g",
    img: "/covo/prod-byzantine.jpg",
    desc: "Woven byzantine-style bracelet with dragon terminals.",
  },
  {
    name: "Charm Pendants",
    purity: "24K HK Gold · 999.9%",
    weight: "1.60 g – 6.64 g",
    img: "/covo/prod-pendants.webp",
    desc: "Cross, ribbon, scepter and dragon-coin pendants — individually tagged by weight.",
  },
  {
    name: "Pixiu Beaded Bracelets",
    purity: "24K HK Gold · 999.9%",
    weight: "11.50 g – 31.56 g",
    img: "/covo/prod-beads.webp",
    desc: "Gold bead bracelets with jade / turquoise accents and Piyao charms.",
  },
  {
    name: "Piyao / Pixiu Charms",
    purity: "24K HK Gold",
    weight: "0.7 g – 1.2 g each",
    img: "/covo/pixiu.webp",
    desc: "Signature wealth charms, sold loose or assembled onto custom bracelets.",
  },
  {
    name: "24K Gold Roses & Décor",
    purity: "24K HK Gold",
    weight: "Ask for details",
    img: "/covo/roses.jpg",
    desc: "Handcrafted gold roses and display pieces.",
  },
];

// Curated primary categories (kept intentionally focused).
export const CATEGORIES = [
  "Piyao / Pixiu charms", "Bracelets", "Chains & necklaces", "Rings",
  "Pendants", "Gold beads", "Jade & gemstone combinations", "Gold bars & coins",
];

// Featured substantive reviews first, then shorter recommendations.
export const FEATURED_REVIEWS = [
  { name: "Maridie Dolor Borlongan", text: "I started buying from COVO around 2017–2018, from their very first store, and I still buy from them today. The staff and owner are accommodating, the designs are beautiful, and they're legitimate. I regularly check for new products." },
  { name: "Ruel Jr Batingal Malabas", text: "My 24K necklace arrived exactly as shown — beautiful and heavy. I've ordered many times online and every transaction went smoothly. Special thanks to Madame Yan Huang." },
  { name: "Gracemer Morales", text: "I ordered remotely and the package arrived undamaged and in good condition. Assistance was quick and easy, and the staff were professional and kind." },
];

export const REVIEWS = [
  { name: "Kendra Felecierta Tarde", text: "Legit 24K gold. Totoo ang timbangan — the weighing is accurate." },
  { name: "Pat Dacs", text: "The best 24K gold store in Ongpin. Their price per gram is cheap — I always buy here." },
  { name: "John Michael Ontong", text: "Super legit. Very accommodating and professional staff. We'll order again." },
  { name: "Celesine CL", text: "Very efficient staff. Trustworthy. I've done two transactions with them." },
  { name: "Rio Gracia", text: "Legit! This was my purchase last year and still in excellent condition." },
  { name: "Jemabel Besa", text: "Staff are kind, the product is legit pawnable, and it's genuinely 24K." },
];

// Simple 4-step explainer — this is an inquiry/reservation site, not checkout ecommerce.
export const ORDER_STEPS = [
  { n: "1", title: "Browse", text: "See available styles, purity and listed weight for each piece." },
  { n: "2", title: "Ask", text: "Message COVO about the exact piece you're interested in." },
  { n: "3", title: "Confirm", text: "COVO confirms availability and today's price." },
  { n: "4", title: "Buy", text: "Arrange purchase or pickup directly with COVO." },
];
